import React from "react";
import { Star } from "lucide-react";

export default function StarRating({ value = 0, size = 16, onChange, className = "" }) {
  const interactive = typeof onChange === "function";
  return (
    <div className={`flex items-center gap-0.5 ${className}`}>
      {[1, 2, 3, 4, 5].map((n) => {
        const filled = value >= n - 0.25;
        return (
          <Star
            key={n}
            size={size}
            onClick={interactive ? () => onChange(n) : undefined}
            className={`${filled ? "fill-sam-amber text-sam-amber" : "text-slate-300"} ${interactive ? "cursor-pointer hover:scale-110 transition-transform" : ""}`}
            data-testid={interactive ? `star-${n}` : undefined}
          />
        );
      })}
    </div>
  );
}
